module.exports = __webpack_public_path__ + "img/wi6teAdd.b13f722f.png";